import React from 'react';
import apiClient from 'axios';
import fileDownload from 'js-file-download';
import Moment from 'moment';

const apiAddress = '/api';

const bearer = sessionStorage["bearer"];
apiClient.defaults.headers.common = { 'Authorization': `Bearer ${bearer}` };


const setBearer = () => {
    const br = sessionStorage["bearer"];
    apiClient.defaults.headers.common = { 'Authorization': `Bearer ${br}` };
}

const isAlive = async () => {
    let api = `/User/IsAlive`;
    await apiGet(apiAddress + "/User/IsAlive").catch((e) => {
        window.location.href = '/';
    })
}

const loadBearer = async () => {
    let ctx = JSON.parse(sessionStorage["context"]);
    await apiClient.post(apiAddress + '/User/refresh-token', { withCredentials: true }).then((r) => {
        //If return not null so the bearer need to be refreshed
        if (r !== null && r.data !== null) {
            sessionStorage["bearer"] = r.data.jwtToken;
            let b = sessionStorage["bearer"];
            apiClient.defaults.headers.common = { 'Authorization': `Bearer ${b}` };
        }
    });

    let _bearer = sessionStorage["bearer"];
    apiClient.defaults.headers.common = { 'Authorization': `Bearer ${_bearer}` };

    return _bearer;
}

const apiPost = async (routeApi, formData) => {
    try {
        return await apiClient.post(routeApi, formData);
    }
    catch (e) {
        loadBearer();
        return await apiClient.post(routeApi, formData);
    }
}

const apiGet = async (routeApi) => {
    try {
        return await apiClient.get(routeApi);
    }
    catch (e) {
        loadBearer();
        return await apiClient.get(routeApi);
    }
}

const getContentTable = async () => {
    let routeApi = '/Dashboard/GetContentReferential';
    let v = await apiGet(apiAddress + routeApi);
    if (v.data !== null) {
        return JSON.stringify(v.data);
    }
    else {
        return null;
    }
}

const getFormuleMedias = async () => {
    let routeApi = '/Dashboard/GetFormulesMedias';
    let v = await apiGet(apiAddress + routeApi);
    if (v.data !== null) {
        return v.data;
    }
    else {
        return null;
    }
}

const getSectors = async () => {
    let routeApi = '/Dashboard/getSectors';
    let v = await apiGet(apiAddress + routeApi);
    if (v.data !== null) {
        return JSON.stringify(v.data);
    }
    else {
        return null;
    }
}

const getControlPanel = async (idc) => {
    var bodyFormData = new FormData();
    bodyFormData.append("idc", idc);
    let routeApi = '/Dashboard/GetControlPanelInfo';
    let v = await apiPost(apiAddress + routeApi, bodyFormData);
    if (v.data !== null) {
        return JSON.stringify(v.data);
    }
    else {
        return null;
    }
}

const doCopyright = async (idc, idSector, title, description, fileCopyright, fileImage) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('IdSector', idSector);
    bodyFormData.append('Title', title);
    bodyFormData.append('Description', description);
    bodyFormData.append('FileCopyright', fileCopyright);
    bodyFormData.append('FileImage', fileImage);
    return await apiPost(apiAddress + "/Dashboard/RegisterCopyright", bodyFormData);
}

const doCopyrightWeb = async (idc, idSector, title, description, websiteUrl, links) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('IdSector', idSector);
    bodyFormData.append('Title', title);
    bodyFormData.append('Description', description);
    bodyFormData.append('WebsiteUrl', websiteUrl);
    bodyFormData.append('Links', links);
    return await apiPost(apiAddress + "/Dashboard/RegisterCopyrightWeb", bodyFormData);
}

const doCopyrightVideo = async (idc, title, description, links) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('Title', title);
    bodyFormData.append('Description', description);
    bodyFormData.append('Links', links);
    return await apiPost(apiAddress + "/Dashboard/RegisterCopyrightVideo", bodyFormData);
}

const doCertifiedEmail = async (idc, subject, message, to, password, fileAttachement) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('Subject', subject);
    bodyFormData.append('Message', message);
    bodyFormData.append('To', to);
    bodyFormData.append('Password', password);
    bodyFormData.append('FileAttachement', fileAttachement);
    return await apiPost(apiAddress + "/Dashboard/SendCertifiedEmail", bodyFormData);
}

const getInvoicesHistoric = async (idc, pageNumber, pageSize, search, forceRefresh) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('PageNumber', pageNumber);
    bodyFormData.append('PageSize', pageSize);
    bodyFormData.append('Search', search);
    bodyFormData.append('ForceRefresh', forceRefresh);
    return await apiPost(apiAddress + "/Dashboard/HistoricInvoices", bodyFormData);
}

const getCopyrightHistoric = async (idc, pageNumber, pageSize, search, forceRefresh) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('PageNumber', pageNumber);
    bodyFormData.append('PageSize', pageSize);
    bodyFormData.append('Search', search);
    bodyFormData.append('ForceRefresh', forceRefresh);
    return await apiPost(apiAddress + "/Dashboard/CopyrightHistorics", bodyFormData);
}

const getCopyrightWebHistoric = async (idc, pageNumber, pageSize, search, forceRefresh) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('PageNumber', pageNumber);
    bodyFormData.append('PageSize', pageSize);
    bodyFormData.append('Search', search);
    bodyFormData.append('ForceRefresh', forceRefresh);
    return await apiPost(apiAddress + "/Dashboard/CopyrightWebHistorics", bodyFormData);
}

const getCertifiedEmailHistoric = async (idc, pageNumber, pageSize, search, forceRefresh) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('PageNumber', pageNumber);
    bodyFormData.append('PageSize', pageSize);
    bodyFormData.append('Search', search);
    bodyFormData.append('ForceRefresh', forceRefresh);
    return await apiPost(apiAddress + "/Dashboard/CertifiedEmailHistorics", bodyFormData);
}

const getWebsiteListing = async (idc, pageNumber, pageSize, search, forceRefresh) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('PageNumber', pageNumber);
    bodyFormData.append('PageSize', pageSize);
    bodyFormData.append('Search', search);
    bodyFormData.append('ForceRefresh', forceRefresh);
    return await apiPost(apiAddress + "/Dashboard/WebsiteListing", bodyFormData);
}

const updateWebsiteUrls = async (idc, websiteId, urls) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('WebsiteId', websiteId);
    bodyFormData.append('Urls', JSON.stringify(urls));
    return await apiPost(apiAddress + "/Dashboard/UpdateWebsiteUrls", bodyFormData);
}

const auth = async (email, password) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Email', email);
    bodyFormData.append('Password', password);
    return await apiPost(apiAddress + "/User/Authentication", bodyFormData);
}

const updateProfil = async (idc, company, firstname, lastname, address, zipcode, city, email, fileProfil) => {
    var bodyFormData = new FormData();
    bodyFormData.append('Idc', idc);
    bodyFormData.append('Company', company);
    bodyFormData.append('FirstName', firstname);
    bodyFormData.append('LastName', lastname);
    bodyFormData.append('Address', address);
    bodyFormData.append('ZipCode', zipcode);
    bodyFormData.append('City', city);
    bodyFormData.append('Email', email);
    bodyFormData.append('FileProfil', fileProfil);
    return await apiPost(apiAddress + "/Dashboard/UpdateProfil", bodyFormData);
}

const sendInvoice = async (row) => {
    console.log(row);
    var bodyFormData = new FormData();
    bodyFormData.append('Id', row.id);
    bodyFormData.append('Date', row.date);
    bodyFormData.append('Description', row.description);
    bodyFormData.append('Qty', row.qty);
    bodyFormData.append('Price', row.price);
    bodyFormData.append('Idc', row.idc);
    bodyFormData.append('CbCheck', row.cbCheck);
    console.log(bodyFormData);
    return await apiPost(apiAddress + "/Dashboard/SendInvoice", bodyFormData);
}

const signOut = async () => {
    await apiGet(apiAddress + "/User/MakeSignOut").then((data) => {
        if (sessionStorage["context"] !== null && sessionStorage["bearer"] !== null) {
            sessionStorage.removeItem("context");
            sessionStorage.removeItem("bearer");
            sessionStorage.removeItem("controlPanel");
            sessionStorage.removeItem("auth");
            sessionStorage.removeItem("contentRef");
        }
        window.location.href = "/";
    });
}

const getReloadPath = async (idc) => {
    return await apiGet(apiAddress + `/Dashboard/GetReloadPath?idc=${idc}`);
}

export default {
    apiGet,
    apiPost,
    loadBearer,
    auth,
    getContentTable,
    setBearer,
    isAlive,
    getControlPanel,
    signOut,
    getSectors,
    doCopyright,
    doCopyrightWeb,
    doCopyrightVideo,
    doCertifiedEmail,
    getCopyrightHistoric,
    getCopyrightWebHistoric,
    getCertifiedEmailHistoric,
    getWebsiteListing,
    updateWebsiteUrls,
    getReloadPath,
    getInvoicesHistoric,
    sendInvoice,
    updateProfil,
    getFormuleMedias
}